import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import './index.css';
import Home from './pages/Home';
import Game from './game/Game';
import Docs from './pages/Docs';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const theme = createTheme({
  palette: {
    primary: { main: '#404040', contrastText: '#fafafa' },
    secondary: { main: '#a3a3a3' },
    background: { default: '#121212', paper: '#2a2a2a' },
    text: { primary: '#fafafa', secondary: '#d4d4d8' },
  },
});

root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/game" element={<Game />} />
        <Route path="/docs" element={<Docs />} />
      </Routes>
    </BrowserRouter>
  </ThemeProvider>
);